import {
  fractionPercentageBarFormatter,
  integerFormatter,
  numberFormatter
} from "../../gridFormatters";
import { wtPctAvg } from "../../math";

export const cloudAllSubscriptions = [
  {
    field: "subscription_name",
    headerName: "Subscription"
  },
  {
    field: "subscription_id",
    headerName: "Subscription ID"
  },
  {
    field: "tenant_id",
    headerName: "Tenant ID"
  },
  {
    field: "spending_limit_setting",
    headerName: "Spending Limit Setting"
  },
];

export const cloudAllResourceGroups = [
  {
    field: "resource_group",
    headerName: "Resource Group"
  },
  {
    field: "location",
    headerName: "Location"
  },
  {
    field: "subscription_name",
    headerName: "Subscription"
  },
  {
    field: "subscription_id",
    headerName: "Subscription ID"
  },
];

export const cloudAllComputeResources = [
  {
    field: "compute_name",
    headerName: "Compute"
  },
  {
    field: "subscription_name",
    headerName: "Subscription"
  },
  {
    field: "subscription_id",
    headerName: "Subscription ID"
  },
  {
    field: "resource_group",
    headerName: "Resource Group"
  },
  {
    field: "location",
    headerName: "Location"
  },
  {
    field: "vcpu",
    type: "numericColumn",
    cellRenderer: integerFormatter,
    headerName: "vCPUs",
    filter: "agNumberColumnFilter",
    aggFunc: "sum"
  },
  {
    field: "disk_alloc",
    type: "numericColumn",
    cellRenderer: numberFormatter,
    headerName: "Disk Size (GiB)",
    filter: "agNumberColumnFilter",
    aggFunc: "sum"
  },
  {
    field: "memory",
    type: "numericColumn",
    cellRenderer: numberFormatter,
    headerName: "Memory Size (GiB)",
    filter: "agNumberColumnFilter",
    aggFunc: "sum"
  },
   {
    field: "os_name",
    headerName: "OS"
  },
  {
    field: "os_version",
    headerName: "OS Version"
  },
  {
    field: "status",
    headerName: "Status"
  },
  {
    field: "hw_profile",
    headerName: "HW Profile"
  },
  {
    field: "cpu_util_pct",
    headerName: "% CPU",
    type: "numericColumn",
    cellRenderer: fractionPercentageBarFormatter,
    enableValue: true,
    // aggFunc: p => wtPctAvg(p, "disk_used", "disk_size"),
    aggFunc: 'avg',
    cellStyle: {
      textAlign: "right"
    },
    filter: "agNumberColumnFilter"
  },
  {
    field: "mem_util_pct",
    headerName: "% Disk",
    type: "numericColumn",
    cellRenderer: fractionPercentageBarFormatter,
    enableValue: true,
    // aggFunc: p => wtPctAvg(p, "disk_used", "disk_size"),
    aggFunc: 'avg',
    cellStyle: {
      textAlign: "right"
    },
    filter: "agNumberColumnFilter"
  },
  {
    field: "latency",
    headerName: "Latency",
    type: "numericColumn",
    cellRenderer: numberFormatter,
    enableValue: true,
    // aggFunc: p => wtPctAvg(p, "disk_used", "disk_size"),
    aggFunc: 'avg',
    cellStyle: {
      textAlign: "right"
    },
    filter: "agNumberColumnFilter"
  },
  {
    field: "write_iops",
    headerName: "Write IOPS",
    type: "numericColumn",
    cellRenderer: numberFormatter,
    enableValue: true,
    // aggFunc: p => wtPctAvg(p, "disk_used", "disk_size"),
    aggFunc: 'avg',
    cellStyle: {
      textAlign: "right"
    },
    filter: "agNumberColumnFilter"
  },
  {
    field: "read_iops",
    headerName: "Read IOPS",
    type: "numericColumn",
    cellRenderer: numberFormatter,
    enableValue: true,
    // aggFunc: p => wtPctAvg(p, "disk_used", "disk_size"),
    aggFunc: 'avg',
    cellStyle: {
      textAlign: "right"
    },
    filter: "agNumberColumnFilter"
  },
];

export const cloudAllStorageAccounts = [
  {
    field: "storage_acc_name",
    headerName: "Storage Account"
  },
  {
    field: "subscription_name",
    headerName: "Subscription"
  },
  {
    field: "subscription_id",
    headerName: "Subscription ID"
  },
  {
    field: "resource_group",
    headerName: "Resource Group"
  },
  {
    field: "location",
    headerName: "Location"
  },
  {
    field: "tier",
    headerName: "Tier"
  },
  {
    field: "sku",
    headerName: "Sku"
  },
  {
    field: "type",
    headerName: "Type"
  },
  {
    field: "used_gb",
    headerName: "Disk Used",
    type: "numericColumn",
    cellRenderer: numberFormatter,
    enableValue: true,
    aggFunc: 'sum',
    cellStyle: {
      textAlign: "right"
    },
    filter: "agNumberColumnFilter"
  },
];